import { createStore ,applyMiddleware } from "redux";
import appReducer from "./reducers/appReducer";
import promiseMiddleware from 'redux-promise';
import { persistStore } from 'redux-persist';
import { composeWithDevTools } from "redux-devtools-extension";

export const store = createStore(appReducer, undefined, composeWithDevTools(), applyMiddleware(promiseMiddleware));

export const persistor = persistStore(store);

export default { store, persistor };


// WEBPACK FOOTER //
// ./src/store.js